__turbopack_context__.v({
  "accessControl": "ShareList-module__cmkv0W__accessControl",
  "entity": "ShareList-module__cmkv0W__entity",
  "list": "ShareList-module__cmkv0W__list",
  "listItem": "ShareList-module__cmkv0W__listItem",
});
